<template>
  <Block class="password-block">
    <template v-slot:header>
      <p>{{ title }}</p>
    </template>

    <md-codebox
      v-model="code"
      :mask="true"
      :maxlength="6"
      @submit="submit(code)"
    />

    <div style="position: relative;">
      <slot name="otp" />
    </div>

    <p v-if="showErr" class="tc red mt60">{{ errMsg }}</p>
  </Block>
</template>

<script>
import Block from '@/components/Block'
import { Codebox, NumberKeyboard } from 'mand-mobile'
export default {
  name: 'SetPassword',

  components: {
    Block,
    [Codebox.name]: Codebox,
    [NumberKeyboard.name]: NumberKeyboard
  },

  props: {
    err: {
      type: String,
      default: ''
    },
    isErr: {
      type: Boolean,
      default: false
    },
    isSetPassword: {
      type: Boolean,
      default: false
    },
    mycode: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      code: this.mycode,
      showErr: this.isErr,
      errMsg: this.err
    }
  },
  watch: {
    err (newVal) {
      this.errMsg = newVal
    },
    isErr (newVal) {
      this.showErr = newVal
    },
    mycode (newVal) {
      this.code = newVal
    }
  },
  methods: {
    // 不能连续字符（如123）连续3位或3位以上
    LxStr (str) {
      const arr = str.split('')
      let flag = true
      for (let i = 1; i < arr.length - 1; i++) {
        const firstIndex = arr[i - 1].charCodeAt()
        const secondIndex = arr[i].charCodeAt()
        const thirdIndex = arr[i + 1].charCodeAt()
        // thirdIndex - secondIndex === 1;
        // secondIndex - firstIndex === 1;
        if (
          (thirdIndex - secondIndex === 1 && secondIndex - firstIndex === 1) ||
          (secondIndex - thirdIndex === 1 && firstIndex - secondIndex === 1)
        ) {
          flag = false
        }
      }
      if (!flag) {
        this.showErr = true
        this.code = ''
        this.errMsg = this.$t('passwordSimple') // 您的密码过于简单，请重新设置
        return flag
      }
      return flag
    },
    // 输完密码后
    submit (code) {
      if (this.isSetPassword) {
        if (!this.LxStr(code)) {
          this.showErr = true
          this.code = ''
          this.errMsg = this.$t('passwordSimple')// 您的密码过于简单，请重新设置
          return false
        } else {
          this.showErr = false
        }
        // 不能相同字符（如111）连续3位或3位以上
        const re = /(\w)*(\w)\2{2}(\w)*/g
        if (re.test(code)) {
          this.code = ''
          this.showErr = true
          this.errMsg = this.$t('passwordSame') // 密码不能为相同的数字，请重新设置
          return false
        } else {
          this.showErr = false
        }
        this.$emit('func1', code)
      } else {
        this.$emit('func2', code)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.password-block {
  /* stylelint-disable selector-pseudo-element-no-unknown, no-duplicate-selectors */
  ::v-deep .flash-block__content {
    height: 490px;

    .flash-block_header {
      padding: 48px 44px 74px 46px;
      font-size: 32px;
      text-align: center;

      p {
        text-align: left;
        display: inline-block;
      }
    }

    .flash-block_body {
      padding-bottom: 100px;
    }

    .md-codebox-box {
      background: #fff;
      border: 2px solid #e5e5e5;
      border-radius: 10px;
    }
  }
}
</style>
